export enum ALIGN_H {
    CENTER = 'center',
    LEFT = 'left',
    RIGHT = 'right',
}
